<section class="details-section" *ngIf="selectedPop || popDetails">
  <div class="details-loading" *ngIf="loadingDetails">
    <i class="pi pi-spin pi-spinner"></i>
  </div>

  <div class="section-header">
    <h3>{{ popDetails ? (popDetails.commercialPop.displayId || 'PoP') : (selectedPop?.displayId ?? 'PoP') }}</h3>
    <div class="section-subtitle" *ngIf="popDetails as details">
      ({{ details.commercialPop.name }} –
      {{ details.commercialPop.city || details.commercialPop.region || '' }} {{ details.commercialPop.country || '' }})
    </div>
    <p>Services provided to {{ selectedCompany?.name }}</p>
  </div>

  <nav class="view-tabs" *ngIf="popDetails">
    <button type="button" [class.active]="viewMode === 'xco'" (click)="viewMode = 'xco'">By XCO</button>
    <button type="button" [class.active]="viewMode === 'service'" (click)="viewMode = 'service'">By Service</button>
  </nav>

  <ng-container *ngIf="viewMode === 'service'">
    <div class="service-tabs" *ngIf="popDetails?.services?.length">
      <div class="service-tab" *ngFor="let service of popDetails?.services"
        [class.service-tab--active]="service.key === activeServiceKey">
        <button type="button" class="service-tab__main" (click)="onSelectService(service.key)">
          {{ service.label }}
        </button>
        <a *ngIf="serviceProfileLink(service.key) as profileLink" class="service-tab__link" [routerLink]="profileLink"
          [attr.title]="'See profile grid for ' + (service.label || serviceLabel(service.key))"
          [attr.aria-label]="'See profile grid for ' + (service.label || serviceLabel(service.key))">
          <span class="sr-only">See profile grid for {{ service.label || serviceLabel(service.key) }}</span>
          <span class="service-tab__link-icon" aria-hidden="true">↗</span>
        </a>
      </div>
    </div>

    <div class="alert alert-info" *ngIf="!loadingDetails && (!popDetails || !activeService)">
      Select a service to inspect its details.
    </div>

    <div class="service-content" *ngIf="!loadingDetails && popDetails && activeService as currentService">
      <article class="product-card" *ngFor="let item of getDisplayItems(currentService)"
        [attr.id]="'service-item-' + item.id" [class.highlight]="item.id === highlightedServiceItemId">
        <header class="product-header">
          <div class="product-title">
            <h4>
              <ng-container
                *ngIf="isBandwidthItem(item) && bandwidthDetailsFor(item) as bandwidth; else defaultProductTitle">
                <a [href]="'#/schedule/etree/' + bandwidth.etreeId" title="Manage E-Tree">
                  {{ bandwidth.scheduleName || item.product.name }}
                </a>
              </ng-container>
              <ng-template #defaultProductTitle>
                {{ item.product.name }}
                &#64;{{ popDetails ? popDetails.commercialPop.displayId : (selectedPop?.displayId ?? 'PoP') }}
              </ng-template>
            </h4>
          </div>
          <span class="status-badge">{{ item.status }}</span>
        </header>
        <ng-container *ngIf="isBandwidthItem(item) && bandwidthDetailsFor(item) as bandwidth; else marketDataMeta">
          <div class="product-meta">
            <div>
              <span class="label" title="E-Tree UUid: {{ bandwidth.etreeId }}">E-Tree ID:</span> {{
              bandwidth.contractReference || bandwidth.etreeId }}
            </div>
            <div class="type-row">
              <span class="label">Type:</span>
              <i class="fa" [ngClass]="bandwidth.role === 'injection' ? 'fa-upload' : 'fa-download'"
                aria-hidden="true"></i>
              <span>{{ bandwidth.role === 'injection' ? 'Injection point' : 'Reception point' }}</span>
            </div>
            <div>
              <span class="label">Technical PoP:</span> {{ formatTechnicalPops(item) || 'N/A' }}
            </div>
            <div>
              <span class="label">{{ crossConnectLabel(getCrossConnectLinks(item).length) }}:</span>
              <ng-container *ngIf="getCrossConnectLinks(item).length; else noCc">
                <span *ngFor="let link of getCrossConnectLinks(item); let last = last">
                  <a class="xco-link" [attr.data-xco-id]="link.id" (click)="onCrossConnectLinkClick(link.id, $event)"
                    title="See XCO details">{{ link.label }}</a>{{ last ? '' : ', ' }}
                </span>
              </ng-container>
              <ng-template #noCc>N/A</ng-template>
            </div>
          </div>
        </ng-container>
        <ng-template #marketDataMeta>
          <div class="product-meta">
            <div><span class="label">Type:</span> {{ formatTypeMeta(item) || 'N/A' }}</div>
            <div><span class="label">Hosting:</span> {{ item.thirdPartyHost || (item.selfHosted ? 'Self-hosted' : 'McKay
              hosted') }}</div>
            <div>
              <span class="label">{{ crossConnectLabel(getCrossConnectLinks(item).length) }}:</span>
              <ng-container *ngIf="getCrossConnectLinks(item).length; else noCc">
                <span *ngFor="let link of getCrossConnectLinks(item); let last = last">
                  <a class="xco-link" [attr.data-xco-id]="link.id" (click)="onCrossConnectLinkClick(link.id, $event)"
                    title="See XCO details">{{ link.label }}</a>{{ last ? '' : ', ' }}
                </span>
              </ng-container>
              <ng-template #noCc>N/A</ng-template>
            </div>
            <div><span class="label">Technical PoP:</span> {{ formatTechnicalPops(item) || 'N/A' }}</div>
          </div>
        </ng-template>

        <div class="bandwidth-details" *ngIf="isBandwidthItem(item) && bandwidthDetailsFor(item) as bandwidth">
          <div class="bandwidth-row" *ngIf="bandwidth.role === 'injection' && bandwidth.injectionMethod">
            <span class="label">Injection method:</span> {{ bandwidth.injectionMethod }}
          </div>
          <div class="bandwidth-row" *ngIf="bandwidth.role === 'injection' && bandwidth.injectionMode">
            <span class="label">Injection mode:</span> {{ bandwidth.injectionMode }}
          </div>
          <div class="bandwidth-row" *ngIf="bandwidth.role === 'injection' && bandwidth.injectionBandwidth">
            <span class="label">Injection bandwidth:</span> {{ bandwidth.injectionBandwidth }} Mbps
          </div>
          <div class="bandwidth-row" *ngIf="bandwidth.vlan">
            <span class="label">Client VLAN:</span> {{ bandwidth.vlan }}
          </div>
          <div class="bandwidth-row" *ngIf="bandwidth.role === 'reception' && bandwidth.receptionMode">
            <span class="label">Reception mode:</span> {{ bandwidth.receptionMode }}
          </div>
          <div class="bandwidth-row"
            *ngIf="bandwidth.role === 'reception' && bandwidthInjection(bandwidth) as injection">
            <span class="label">Injection point:</span>
            <div class="bandwidth-endpoint">
              <i class="fa fa-upload" aria-hidden="true"></i>
              <span class="endpoint-label">
                {{ injection.popDisplayId || injection.popName || 'PoP' }} –
                <a class="xco-link" (click)="onBandwidthEndpointClick(injection, $event)" title="See XCO details">{{
                  injection.crossConnectId }}
                  <ng-container *ngIf="injection.technicalPop?.technicalId">
                    ({{ injection.technicalPop.technicalId }})
                  </ng-container>
                </a>
              </span>
              <small *ngIf="injection.mode">({{ injection.mode }})</small>
            </div>
          </div>
          <div class="bandwidth-row"
            *ngIf="bandwidth.role === 'injection' && getReceptionEntries(item).length as count">
            <span class="label">{{ count === 1 ? 'Reception point:' : 'Reception points:' }}</span>
            <div class="bandwidth-endpoint" *ngFor="let reception of getReceptionEntries(item)">
              <i class="fa fa-download" aria-hidden="true"></i>
              <span class="endpoint-label">
                {{ reception.endpoint.popDisplayId || reception.endpoint.popName || 'PoP' }} –
                <a class="xco-link" (click)="onBandwidthEndpointClick(reception.endpoint, $event)"
                  title="See XCO details">{{ reception.endpoint.crossConnectId }}
                  <ng-container *ngIf="reception.endpoint.technicalPop?.technicalId">
                    ({{ reception.endpoint.technicalPop.technicalId }})
                  </ng-container>
                </a>
              </span>
              <small *ngIf="reception.endpoint.mode">({{ reception.endpoint.mode }})</small>
              <span class="reception-meta" *ngIf="reception.vlan">VLAN {{ reception.vlan }}</span>
            </div>
          </div>
        </div>

        <div class="assoc-loading" *ngIf="item.symbolsLoading">
          <i class="pi pi-spin pi-spinner"></i>
        </div>

        <div class="assoc-section" *ngIf="item.symbols?.length">
          <div class="assoc-block">
            <h6>Associated symbols</h6>
            <div class="assoc-table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Asset Class</th>
                    <th>Name</th>
                    <th>Maturity</th>
                    <th>{{ symbolColumnLabel(item) }}</th>
                    <th *ngIf="item.service?.toLowerCase() === 'qfd'">QFD Channel</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let symbol of item.symbols">
                    <td>{{ symbol.assetClass || '-' }}</td>
                    <td [innerHTML]="symbol.name || '-'"></td>
                    <td>{{ symbol.maturity || '-' }}</td>
                    <td>{{ symbol.symbol || '-' }}</td>
                    <td *ngIf="item.service?.toLowerCase() === 'qfd'">{{ symbol.channelCode || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="assoc-section" *ngIf="item.channels?.length && item.service?.toLowerCase() !== 'qfd'">
          <div class="assoc-block">
            <h6>Associated channels</h6>
            <div class="assoc-table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Cross-Connect</th>
                    <th>Channel</th>
                    <th>Permissioning ID</th>
                    <th>Multicast / IP</th>
                    <th>Port</th>
                    <th>Platform</th>
                    <th>Layer</th>
                    <th>Status</th>
                    <th>Updated</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let channel of item.channels">
                    <td>{{ channel.crossConnectId || '-' }}</td>
                    <td>{{ channel.channelCode || '-' }}</td>
                    <td>{{ channel.permissioningId || '-' }}</td>
                    <td>{{ channel.permissioningIp || '-' }}</td>
                    <td>{{ channel.port || '-' }}</td>
                    <td>{{ channel.platform || '-' }}</td>
                    <td>{{ formatLayer(channel.layer) }}</td>
                    <td>
                      <span [ngClass]="channelStatusClass(channel.configStateStatus)">
                        {{ channel.configStateStatus || '-' }}
                      </span>
                    </td>
                    <td>
                      {{ channel.configStateAppliedDate ? (channel.configStateAppliedDate | date:'yyyy-MM-dd') : '-' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="assoc-section" *ngIf="item.histories?.length">
          <div class="assoc-block">
            <h6>Service history</h6>
            <div class="assoc-table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Start date</th>
                    <th>End date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let history of item.histories">
                    <td>{{ history.type }}</td>
                    <td>{{ history.startDate || '-' }}</td>
                    <td>{{ history.endDate || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </article>
    </div>
  </ng-container>

  <ng-container *ngIf="viewMode === 'xco'">
    <div class="xco-list" *ngIf="!loadingDetails && xcoGroups.length > 0; else noXco">
      <ng-container *ngFor="let group of xcoGroups; let last = last">
        <div class="xco-group" [attr.id]="'xco-' + group.xcoId" [class.highlight]="group.xcoId === highlightedXcoId">
          <div class="xco-header-wrapper">
            <h4>
              XCO: {{ group.xcoId }}
              <ng-container *ngIf="isAddpEligible(group)">
                <button *roles="['ROLE_MCKAY_ADMIN']" type="button" class="addp-btn" (click)="openAddpDialog(group)">
                  <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                  Purchase an extra XCO (ADDP)
                </button>
              </ng-container>
            </h4>
          </div>
          <small class="xco-datacenter" *ngIf="datacenterRefForGroup(group) as datacenterRef">
            Datacenter ref: {{ datacenterRef }}
          </small>
          <div class="xco-items">
            <article class="product-card simple" *ngFor="let entry of group.items">
              <header class="product-header">
                <div class="product-title">
                  <h4>
                    <span class="service-tag" [ngClass]="serviceTagClass(entry.serviceKey)">{{ entry.serviceLabel
                      }}</span>
                    <ng-container
                      *ngIf="isBandwidthItem(entry.item) && bandwidthDetailsFor(entry.item) as entryBandwidth; else defaultXcoTitle">
                      <a href="#"
                        (click)="navigateToServiceItem(entry.serviceKey, entry.item); $event.preventDefault();"
                        title="See E-Tree details for this PoP">
                        {{ entryBandwidth.scheduleName || entry.item.product.name }}
                      </a>
                    </ng-container>
                    <ng-template #defaultXcoTitle>
                      <a href="#"
                        (click)="navigateToServiceItem(entry.serviceKey, entry.item); $event.preventDefault();"
                        title="See item details">
                        {{ entry.item.product.name }}
                        &#64;{{ popDetails?.commercialPop.displayId || 'PoP' }}
                      </a>
                    </ng-template>
                  </h4>
                </div>
                <span class="status-badge">{{ entry.item.status }}</span>
              </header>
              <ng-container
                *ngIf="isBandwidthItem(entry.item) && bandwidthDetailsFor(entry.item) as entryBandwidth; else marketDataXcoMeta">
                <div class="product-meta">
                  <div><span class="label" title="E-Tree UUid: {{ entryBandwidth.etreeId }}">E-Tree ID:</span> {{
                    entryBandwidth.contractReference || entryBandwidth.etreeId }}</div>
                  <div class="type-row">
                    <span class="label">Type:</span>
                    <i class="fa" [ngClass]="entryBandwidth.role === 'injection' ? 'fa-upload' : 'fa-download'"
                      aria-hidden="true"></i>
                    <span>{{ entryBandwidth.role === 'injection' ? 'Injection point' : 'Reception point' }}</span>
                  </div>
                  <div><span class="label">Technical PoP:</span> {{ getTechnicalPopForXco(entry.item, group.xcoId) ||
                    'N/A' }}</div>
                </div>
              </ng-container>
              <ng-template #marketDataXcoMeta>
                <div class="product-meta">
                  <div><span class="label">Type:</span> {{ formatTypeMeta(entry.item) || 'N/A' }}</div>
                  <div><span class="label">Hosting:</span> {{ entry.item.thirdPartyHost || (entry.item.selfHosted ?
                    'Self-hosted' : 'McKay hosted') }}</div>
                  <div><span class="label">Technical PoP:</span> {{ getTechnicalPopForXco(entry.item, group.xcoId) ||
                    'N/A' }}</div>
                </div>
              </ng-template>
            </article>
          </div>
        </div>
      </ng-container>
    </div>
    <ng-template #noXco>
      <div class="alert alert-info" *ngIf="!loadingDetails">No Cross-Connects found for this PoP.</div>
    </ng-template>
  </ng-container>
</section>

<app-addp-dialog
  *ngIf="addpDialogGroup && popDetails?.commercialPop"
  [visible]="addpDialogVisible"
  (visibleChange)="onAddpDialogVisibilityChange($event)"
  [company]="selectedCompany"
  [pop]="popDetails.commercialPop || selectedPop"
  [group]="addpDialogGroup"
  [items]="addpDialogItems">
</app-addp-dialog>
